import { authenticateService } from "../services/CommonService";

export const isAuthenticated = async () => {
  const token = await authenticateService();
  if (token) {
    return true;
  } else {
    return false;
  }
};

export const convertUTCtoLocalTime = (date, time) => {
  // const utcDate = "2023-04-26T14:35:38.793466Z";
  const localDateTime = new Date(date).toLocaleString(
    "en-US",
    {
      hour12: false,
    }
  );
  if(localDateTime === "Invalid Date") {
    return "Invalid Date";
  }
  const localTime = localDateTime.split(",")[1].trim();
  const hoursAndMinutes = localTime.split(":").slice(0, 2).join(":");
  return hoursAndMinutes;
};

export const convertUTCtoLocalDate = (date, time) => {
  const localDateTime = new Date(date).toLocaleString(
    "en-US",
    {
      hour12: false,
    }
  );
  if(localDateTime === "Invalid Date") {
    return "Invalid Time";
  }
  // get date
  const localDate = localDateTime.split(",")[0].trim();

  // get month with name
  const monthName = localDate.split("/")[0];

  // get year
  const year = localDate.split("/")[2];

  // return date with month name and year

  return (
    ("0" + localDate.split("/")[1]).slice(-2) +
    " " +
    new Date(`${monthName}/1/2021`).toLocaleString("default", { month: "long" }) +
    " " +
    year
  );
 
};

export const convertUTCtoLocalTimeWithAMorPM = (date, time) => {
  // const utcDate = "2023-04-26T14:35:38.793466Z";
  // get AM or PM

  const localDateTime = new Date(date).toLocaleString("en-US", {
    hour12: true,
  });
  if (localDateTime === "Invalid Date") {
    return "Invalid Date";
  }
  const localTime = localDateTime.split(",")[1].trim();
  // get am or pm
  const amOrPm = localTime.split(" ")[1];
  const hoursAndMinutes =
    localTime.split(":").slice(0, 2).join(":") + " " + amOrPm;

  return hoursAndMinutes;
};
